import React from "react";
import { Helmet } from "react-helmet";
import { Box, BoxProps } from "@mui/material";

interface IPageProps extends BoxProps {
    title?: string;
    children?: React.ReactNode;
}

const Page = (props: IPageProps) => {
    return (
        <>
            <Helmet>
                <title>{props.title}</title>
            </Helmet>

            <Box
                sx={{
                    p: 1.5,
                    backgroundColor: "transparent", // ? ?? n?n theo workspace (bg #f6f7f9)
                    borderRadius: 2,
                    minHeight: 0,                   // ? quan tr?ng cho flex
                    overflow: "visible",            // ? KH�NG scroll ? ?�y
                    ...props.sx,
                }}
            >
                {props.children}
            </Box>
        </>
    );
};

export default Page;